/** Perspectiva dos títulos */
export interface TituloReceberPerspectiva {
    id: number;
    nome: string;
}

export const perspectivaTodos: TituloReceberPerspectiva = {
    id: 1,
    nome: 'Todos os títulos'
};

export const perspectivaEmAberto: TituloReceberPerspectiva = {
    id: 2,
    nome: 'Títulos em aberto'
};

export const perspectivaPagos: TituloReceberPerspectiva = {
    id: 3,
    nome: 'Títulos pagos'
};

export const perspectivaVencidos: TituloReceberPerspectiva = {
    id: 4,
    nome: 'Títulos vencidos'
};

export const tituloReceberPerspectivas: TituloReceberPerspectiva[] = [
    perspectivaTodos,
    perspectivaEmAberto,
    perspectivaPagos,
    perspectivaVencidos
];

/** Verifica se a perspectiva é de Todos */
export function isPerspectivaTodos(perspectiva: number): boolean {
    return perspectiva === perspectivaTodos.id;
}

/** Verifica se a perspectiva é de Em Aberto */
export function isPerspectivaEmAberto(perspectiva: number): boolean {
    return perspectiva === perspectivaEmAberto.id;
}

/** Verifica se a perspectiva é de Pagos */
export function isPerspectivaPagos(perspectiva: number): boolean {
    return perspectiva === perspectivaPagos.id;
}

/** Verifica se a perspectiva é de Vencidos */
export function isPerspectivaVencidos(perspectiva: number): boolean {
    return perspectiva === perspectivaVencidos.id;
}
